import React, { useEffect } from "react";
import { Col, Row, Card, Button, Form, Input, Breadcrumb } from "antd";
import useAuth from "../hooks/useAuth";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { fetchUserAsync, persistUser } from "../features/user/userSlice";
import { changePassword, updateUser } from "../features/user/userAPI";
import FormItemLabel from "antd/es/form/FormItemLabel";
import { Link } from "react-router-dom";

export default function Settings() {
    const dispatch = useDispatch();
    const { auth } = useAuth();

    const { organisation } = useSelector((state) => state.organisation);
    const data = useSelector((state) => state.user.user);
    const status = useSelector((state) => state.user.status);
    const error = useSelector((state) => state.user.error);
    const isEmail = data.attributes?.email !== data.attributes?.username;

    const [passwordForm, setPasswordForm] = React.useState({});
    const [savingPassword, setSavingPassword] = React.useState(false);

    useEffect(() => {
        if (status === "idle" || (status === "fulfilled" && !data)) {
            const user = auth.getUser();
            dispatch(fetchUserAsync(user.id));
        }
    }, [auth, dispatch, status, data]);

    if (status === "pending" || !data) return <div className="AlertInfo Loading">Loading...</div>;
    if (error) return <p>Error :(</p>;

    const updateUserDetails = async (values) => {
        try {
            const user = auth.getUser();
            const response = await updateUser(user.id, values);
            dispatch(persistUser({ ...data, attributes: response }));
            toast("Profile updated successfully", { type: "success" });
        } catch (error) {
            toast("Failed to update profile", { type: "error" });
            console.error(error);
        }
    };

    const updatePassword = async (values) => {
        try {
            const token = auth.getToken();
            setSavingPassword(true);
            console.log(values);
            const response = await changePassword(values.currentPassword, values.newPassword, token);
            console.log(response);
            setPasswordForm({});
            setSavingPassword(false);
            toast("Password updated successfully", { type: "success" });
        } catch (error) {
            toast("Failed to update password", { type: "error" });
            console.error(error);
            setSavingPassword(false);
        }
    };

    const separateDANumber = !!organisation?.attributes?.LMS?.seperate_DA_number_in_registration;


    return (
        <div className="Settings PageSingle">
            <div className="AppContainer">
                <Breadcrumb
                    className="Breadcrumb"
                    items={[
                        {
                            title: <Link to="/">Home</Link>,
                        },
                        {
                            title: "Settings",
                        },
                    ]}
                />
                <Row gutter={[20, 20]}>
                    <Col xs={{ span: 24, order: 1 }} md={{ span: 16, order: 1 }}>
                        <Card bordered={false} className="CardItem">
                            <h1 className="title">Profile Settings</h1>
                            <Form
                                name="normal_login"
                                className="login-form"
                                initialValues={{
                                    ...data.attributes,
                                    remember: true,
                                }}
                                size="large"
                                onFinish={updateUserDetails}
                                layout="vertical"
                            >
                                <Form.Item
                                    name="firstname"
                                    label="First Name"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please input your First Name!",
                                        },
                                    ]}
                                >
                                    <Input />
                                </Form.Item>
                                <Form.Item
                                    name="lastname"
                                    label="Last Name"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please input your Last Name!",
                                        },
                                    ]}
                                >
                                    <Input />
                                </Form.Item>
                                <Form.Item
                                    name="phone"
                                    label="Phone Number"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please input your Phone Number! (04XXXXXXXX)'",
                                            pattern: /^04\d{8}$/,
                                        },
                                    ]}
                                >
                                    <Input />
                                </Form.Item>
                                <Form.Item
                                    name="user_identifier"
                                    label="Username"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please input your User Name!",
                                        },
                                    ]}
                                >
                                    <Input />
                                </Form.Item>
                                {isEmail && (
                                    <Form.Item
                                        name="email"
                                        label="Email"
                                        rules={[
                                            {
                                                required: true,
                                                type: "email",
                                                message: "Please input your Email!",
                                            },
                                        ]}
                                    >
                                        <Input />
                                    </Form.Item>
                                )}

                                <Form.Item name="DriverAuthorityID" label={separateDANumber? "Taxi Driver ID" :"Driver Authority ID"}>
                                    <Input readOnly />
                                </Form.Item>
                                <Form.Item>
                                    <Button type="primary" htmlType="submit" className="login-form-button" size="small">
                                        Save
                                    </Button>
                                </Form.Item>
                            </Form>
                        </Card>
                    </Col>
                    <Col xs={{ span: 24, order: 2 }} md={{ span: 8, order: 2 }}>
                        <Card bordered={false} className="CardItem">
                            <h1 className="title">Change Password</h1>
                            <Form
                                name="normal_login"
                                className="login-form"
                                initialValues={passwordForm}
                                size="large"
                                onFinish={updatePassword}
                                layout="vertical"
                            >
                                <Form.Item
                                    name="currentPassword"
                                    label="Current Password"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please input your Current Password!",
                                        },
                                    ]}
                                >
                                    <Input type="password" />
                                </Form.Item>
                                <Form.Item
                                    name="newPassword"
                                    label="New Password"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please input your New Password!",
                                        },
                                    ]}
                                >
                                    <Input type="password" />
                                </Form.Item>
                                <Form.Item>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        className="login-form-button"
                                        size="small"
                                        loading={savingPassword}
                                    >
                                        Save
                                    </Button>
                                </Form.Item>
                            </Form>
                        </Card>
                    </Col>
                </Row>
            </div>
        </div>
    );
}
